<form [formGroup]="form" class="form">
  @if (isLoaded()) {
    <ldw-vmp-form-group
      [captionWidth]="captionWidth"
      [valueWidth]="valueWidth"
      [form]="form"
      [expanded]="true"
      [vmpList]="groupData" />
  }
  @if (isLoaded() && hasProcessData()) {
    <ldw-vmp-form-group
      [captionWidth]="captionWidth"
      [valueWidth]="valueWidth"
      [form]="form"
      [expanded]="true"
      [vmpList]="groupProcess" />
  }
</form>
